import type { Workflow, WorkflowType } from '@lighthouse/shared'
import { WorkflowRunType } from '@lighthouse/shared'

export const getWorkflowRunType = (type: WorkflowType) => {
    if (type === 'automation') {
        return WorkflowRunType.PARALLEL
    }
    return WorkflowRunType.SEQUENTIAL
}

export const getWorkflowRootNode = (workflow: Workflow | undefined) => {
    return workflow?.content?.nodes?.[0]
}
